import { mergeArrays } from "./modules/utils";

const SubjectTypePolicy = {
  Subject: {
    fields: {
      benchmarkLevels: {
        merge: mergeArrays,
      },
    },
  },
};

export default SubjectTypePolicy;
